import "./events.css";

import React from "react";

import { ANCHORS, EVENTS, ROUTES } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { PageHero, PhotoStrip, Split, SplitItem, TitleBand } from "../general/PageSections";
import Testimonials from "../general/Testimonials";
import EventEnquiryForm from "./EventEnquiryForm";

const Events = () => {
  //{ type } - a new object each click, so clicking the same button twice still scrolls
  const [presetType, setPresetType] = React.useState(null);
  const firstFieldRef = React.useRef(null);
  const reducedMotion = React.useMemo(() => window.matchMedia("(prefers-reduced-motion: reduce)").matches, []);

  //Event type buttons open the form with that type already chosen
  const chooseType = (type) => (e) => {
    e.preventDefault();
    setPresetType({ type });
    document.getElementById(ANCHORS.EVENT_FORM).scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth" });
    if (firstFieldRef.current) {
      firstFieldRef.current.focus({ preventScroll: true });
    }
  };

  return (
    <React.Fragment>
      <PageMeta
        title={EVENTS.TITLE}
        description={EVENTS.DESCRIPTION}
      />
      <PageHero src={"/images/events/event-table.webp"} />
      <TitleBand
        title={EVENTS.TITLE}
        isDisplayFont
      />

      <Split image={{ src: "/images/events/poolside-table.webp", alt: "A long table decorated with flowers beside the pool", width: 1124, height: 1185 }}>
        <div className={"split-item"}>
          <h2 className={"heading is-display"}>{EVENTS.WELCOME_TITLE}</h2>
          <p className={"events-welcome"}>{EVENTS.WELCOME}</p>
          <ul className={"events-types"}>
            {EVENTS.EVENT_TYPES.map((type) => (
              <li key={type}>
                <a
                  href={`${ROUTES.EVENTS}#${ANCHORS.EVENT_FORM}`}
                  className={"btn"}
                  onClick={chooseType(type)}
                >
                  {type}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </Split>

      {EVENTS.SPLITS.map((split) => (
        <Split
          key={split.title}
          image={split.image}
          isImageFirst={split.isImageFirst}
        >
          <SplitItem
            title={split.title}
            text={split.text}
            isDisplayFont
          />
        </Split>
      ))}

      <section className={"statement"}>
        <div className={"container"}>
          <p className={"statement-text is-display"}>{EVENTS.SURROUNDINGS}</p>
        </div>
      </section>

      <section className={"events-features"}>
        <div className={"events-features-grid container"}>
          {EVENTS.FEATURES.map((feature) => (
            <div key={feature.title}>
              <h2 className={"heading is-display"}>{feature.title}</h2>
              <p className={"body-text"}>{feature.text}</p>
            </div>
          ))}
        </div>
      </section>

      <PhotoStrip src={"/images/about/garden-table.webp"} />

      <section className={"text-band"}>
        <div className={"container"}>
          <h2 className={"heading is-display"}>{EVENTS.SERVICE_TITLE}</h2>
          <p className={"body-text"}>{EVENTS.SERVICE}</p>
        </div>
      </section>

      <Testimonials
        title={EVENTS.TESTIMONIALS_TITLE}
        items={EVENTS.TESTIMONIALS}
      />

      <Split
        id={ANCHORS.EVENT_FORM}
        media={(
          <video
            src={"/images/events/enquire.mp4"}
            poster={"/images/events/enquire-poster.webp"}
            autoPlay={!reducedMotion}
            muted
            loop
            playsInline
            preload={"metadata"}
            aria-hidden={"true"}
          />
        )}
      >
        <div className={"split-item events-enquire"}>
          <h2 className={"heading is-display"}>{EVENTS.FORM_TITLE}</h2>
          <EventEnquiryForm
            presetType={presetType}
            firstFieldRef={firstFieldRef}
          />
        </div>
      </Split>

      <PhotoStrip src={"/images/events/chairs-lawn.webp"} />

      <section className={"text-band"}>
        <div className={"container"}>
          <h2 className={"heading is-display"}>{EVENTS.PROMISE_TITLE}</h2>
          <p className={"body-text"}>{EVENTS.PROMISE}</p>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Events;
